module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABGdBTUEAALGPC/xhBQAAAUVJREFUOBGtlLtSwzAQRa8UDxUpDHTwC/Sk5yOgg0/g1VHS0xEKWqCkgyYFHTXDN/AqGPNqCI7NvXGUx1hyDMPO7Hi10j3SyvYa0FoH+WKe4jDLsMphrFwNS6xFx0TYutk390aQXhd3BmjmQFQDMFxCTUrNR2MGy1Yn+QtENG3c15IRDcr51UmGRxrAcl6JZVx5JwtNYH52XOqNY4GCJkB7AzjenA4LggQRYGmu8GkwL8hBHt+Ay1vgiv7EuApWAjnIwyuwewZ0U+CLrvj5PQwrgdZbgCB75wXEXaBgO6cFbG3FZUfP0ms/6gAN4r97o0UuEmybMN9cCZTxK8s8EAdTqT4rleZbVCf3byCVltDj0K4n16GZiTw7gVoB/+KJ9Njg5ROQh0xaMaz6iVpBFawK0teSYdWU1E+MxQUFKrOuJdJIK8YPBDRtUK2fzbsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/adv/advertising_ascending_selected.png
// module id = p5cp
// module chunks = 1